<div 
    class="loading"
    *ngIf="isLoading$ | async"
>
    Loading&#8230;
</div>